import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

const debug = process.env.NODE_ENV !== 'production'

export const store = new Vuex.Store({
  strict: debug,
  plugins: [createPersistedState()],
  state: {
    accessDate: null,
    accessToken: null,
    instanceUrl: null,
  },
  mutations: {
    setAccessToken(state, token) {
      state.accessToken = token
    },
    setAccessDate(state, date) {
      state.accessDate = date
    },
    setInstanceUrl(state, url) {
      state.instanceUrl = url
    }
  }
})
